<div class="image-merging">
  <div class="toolbar">
    <button mat-icon-button class="arrow-button" (click)="navigateDate(-1)">
      <mat-icon class="icon-button">keyboard_arrow_left</mat-icon>
    </button>

    <app-range-picker (change)="onDateChanged($event)" [startDate]="startDate" [endDate]="endDate"></app-range-picker>

    <button mat-icon-button class="arrow-button" (click)="navigateDate(1)">
      <mat-icon class="icon-button">keyboard_arrow_right</mat-icon>
    </button>
  </div>

  <div class="image-form">
    <mat-form-field appearance="outline" class="input-full-width">
      <mat-label>Unit</mat-label>
      <mat-select id="model" [(ngModel)]="selectedUnit" (selectionChange)="setUnit()">
        <mat-option>Select one ...</mat-option>
        <mat-option *ngFor="let unit of units" [value]="unit.id">{{ unit.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Image scale</mat-label>
      <input matInput [(ngModel)]="imageScale" type="number" min="0.01" step="0.01" (change)="drawCanvas(true)" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Angle offset</mat-label>
      <input matInput [(ngModel)]="angleOffset" type="number" min="0" step="1" (blur)="drawCanvas(true)" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Lens Angle</mat-label>
      <input matInput [(ngModel)]="angle" type="number" min="1" max="80" step="1" (change)="drawCanvas(true)" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Crop %</mat-label>
      <input matInput [(ngModel)]="crop" type="number" min="0" max="49" step="1" (change)="drawCanvas(true)" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Min Z ({{ box.min.z }})</mat-label>
      <input matInput [(ngModel)]="minZ" type="number" (change)="drawCanvas()" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Max Z ({{ box.max.z }})</mat-label>
      <input matInput [(ngModel)]="maxZ" type="number" (change)="drawCanvas()" />
    </mat-form-field>
  </div>

  <button mat-stroked-button (click)="exportCanvas()">Export as JPEG</button>

  <ng-container *ngIf="loading"> loading... </ng-container>

  <div class="image-container">
    <canvas #imageContainer width="{{ canvasWidth }}" height="{{ canvasHeight }}"></canvas>
  </div>
</div>
